
export const name = "web-interactives-dashboard-ui";
export const version = "dev";
